export const dbFields =
{
    id: {
        visiable: false,
        title: 'Id',
        key: 'id'
    },
    name: {
        visiable: true,
        title: 'Name',
        key: 'name'
    },
    group: {
        visiable: true,
        title: 'Group',
        key: 'group_id'
    },
    req: {
        visiable: true,
        title: 'RequestId',
        key: 'req_id'
    },
    method: {
        visiable: true,
        title: 'Method',
        key: 'methods'
    },
    module: {
        visiable: true,
        title: 'Module',
        key: 'modules'
    },
    action: {
        visiable: true,
        title: 'Action',
        key: 'actions'
    },
    type: {
        visiable: true,
        title: 'Type',
        key: 'type'
    },
    
    createdAt: {
        visiable: true,
        title: 'Created',
        key: 'created_at'
    },
};
